import React, { useEffect, useState } from 'react';
import { listUsers, createUser, updateUser, deleteUser } from '../api/users';
import UserForm from '../components/UserForm';
import Button from '../components/common/Button';
import './Users.css';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);

  async function load() {
    setLoading(true);
    setError(null);
    try {
      const data = await listUsers();
      setUsers(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e.message || 'Kullanıcılar yüklenemedi');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  async function handleCreate(payload) {
    try {
      await createUser(payload);
      await load();
      setShowForm(false);
    } catch (e) {
      setError(e.message || 'Oluşturulamadı');
    }
  }

  async function handleUpdate(id, payload) {
    try {
      await updateUser(id, payload);
      await load();
      setEditing(null);
      setShowForm(false);
    } catch (e) {
      setError(e.message || 'Güncellenemedi');
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Bu kullanıcıyı silmek istediğinizden emin misiniz?')) return;
    try {
      await deleteUser(id);
      await load();
    } catch (e) {
      setError(e.message || 'Silinemedi');
    }
  }

  return (
    <div className="users-page">
      <div className="users-header">
        <h1>👥 Kullanıcı Yönetimi</h1>
        <p>Kullanıcıları görüntüleyin ve yönetin</p>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="users-section">
        <div className="users-actions">
          <Button onClick={() => { setEditing(null); setShowForm(true); }}>
            Yeni Kullanıcı
          </Button>
          <Button variant="secondary" onClick={load}>
            Yenile
          </Button>
        </div>

        {showForm && (
          <div className="form-container">
            <UserForm
              initialValues={editing || { name: '', email: '', role: 'user' }}
              onCancel={() => { setShowForm(false); setEditing(null); }}
              onSubmit={async (values) => {
                if (editing && (editing.id || editing._id)) {
                  await handleUpdate(editing.id || editing._id, values);
                } else {
                  await handleCreate(values);
                }
              }}
            />
          </div>
        )}

        {loading ? (
          <div className="loading">Yükleniyor...</div>
        ) : (
          <table className="users-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>İsim</th>
                <th>E-posta</th>
                <th>Rol</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id || u._id}>
                  <td>{u.id || u._id}</td>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{u.role}</td>
                  <td>
                    <Button 
                      variant="secondary"
                      onClick={() => { setEditing(u); setShowForm(true); }}
                    >
                      Düzenle
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => handleDelete(u.id || u._id)}
                    >
                      Sil
                    </Button>
                  </td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td colSpan={5} className="users-empty">
                    Kayıtlı kullanıcı yok.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
